export default __webpack_public_path__ + "static/media/Eminent Girdle.486478cb.jpg";